<p class="denied-message">{{ message }}</p>
